import(/* webpackMode: "eager" */ "/app/src/store/courseStoreProvider.tsx");
